import React, { useCallback } from 'react';
import { Tappable } from '@vectord/components';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';

import {
  setViewMiscellaneousMenteeModulesState,
  viewMiscellaneousMenteeModulesStateSelector,
} from 'features/moduleManagement';
import styles from './ViewMiscellaneousButton.module.scss';

function ViewMiscellaneousButton() {
  const dispatch = useDispatch();
  const viewMiscellaneousModulesState = useSelector(
    viewMiscellaneousMenteeModulesStateSelector
  );

  const handleOnClick = useCallback(() => {
    dispatch(
      setViewMiscellaneousMenteeModulesState(!viewMiscellaneousModulesState)
    );
  }, [dispatch, viewMiscellaneousModulesState]);

  return (
    <Tappable
      onClick={handleOnClick}
      className={classNames('btn btn-outlined btn-primary', styles.root)}
    >
      {viewMiscellaneousModulesState
        ? 'View Core Curriculum Modules'
        : 'View Miscellaneous Modules'}
    </Tappable>
  );
}

export default ViewMiscellaneousButton;
